/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Shore } from '../../models/shore';
import { UpdateShoreDto } from '../../models/update-shore-dto';

export interface UpdateOneBaseMgmtShoreControllerShore$Params {
  id: number;
      body: UpdateShoreDto
}

export function updateOneBaseMgmtShoreControllerShore(http: HttpClient, rootUrl: string, params: UpdateOneBaseMgmtShoreControllerShore$Params, context?: HttpContext): Observable<StrictHttpResponse<Shore>> {
  const rb = new RequestBuilder(rootUrl, updateOneBaseMgmtShoreControllerShore.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Shore>;
    })
  );
}

updateOneBaseMgmtShoreControllerShore.PATH = '/api/mgmt/shore/{id}';
